<template>
  <v-card class="pa-4 box_shadow_class">
    <div>
      <div>
        <span>
          <HeaderComponent :headerTitle="headerText" />
        </span>
      </div>

      <v-container class="ma-0 pa-0" fluid grid-list-lg>
        <v-layout class="ma-0 pa-0" row wrap>
          <v-col class="m-1">
            <v-row>
              <v-col xs3 cols="3" sm="3" md="3">
                <router-link :to="{ name: 'locationMaster' }">
                  <v-card class="pa-4 box_shadow_class">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/location_module.png" width="108" height="108" />
                    </div>
                    <div class="mt-3 text-color" align="center" justify="center">
                      Location Module
                    </div>
                  </v-card>
                </router-link>
              </v-col>
            </v-row>
          </v-col>
        </v-layout>
      </v-container>

    </div>
  </v-card>
</template>

<style scoped>
.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)>.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none;
  visibility: hidden;
}

.text-color {
  color: #0357d0;
}

.header-background {
  background-color: #0357d0;
}

.box_shadow_class {
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 4px;
}

/* .v-card {
  max-width: 97% !important;
} */

.v-card-100 {
  max-width: 100% !important;
}
</style>

<script>
import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      headerText: "Location Master"
    };
  },

  components: {
    HeaderComponent,
  },

  computed: mapState(["currentUser", "signedIn"])
};
</script>